// app/frontend/pages/Feedback.tsx
import React, { useEffect } from 'react';
import { Head } from '@inertiajs/react';
import Layout from '../components/Layout';

interface FeedbackProps {
  token?: string;
}

// Extend Window interface to include Canny
declare global {
  interface Window {
    Canny: any;
  }
}

const Feedback: React.FC<FeedbackProps> = ({ token }) => {
  useEffect(() => {
    console.log('Hello from the feedback page');
    console.log('Token:', token);

    // Load Canny SDK
    const loadCannySDK = () => {
      if (!document.getElementById('canny-jssdk')) {
        const script = document.createElement('script');
        script.id = 'canny-jssdk';
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://canny.io/sdk.js';

        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode?.insertBefore(script, firstScript);
      }
    };

    // Initialize Canny queue if SDK not yet ready
    if (typeof window.Canny !== 'function') {
      const cannyQueue: any[] = [];
      window.Canny = function (...args: any[]) {
        cannyQueue.push(args);
      };
      window.Canny.q = cannyQueue;
    }

    // Load SDK on page load or immediately if already loaded
    if (document.readyState === 'complete') {
      loadCannySDK();
    } else {
      window.addEventListener('load', loadCannySDK);
    }

    // Once SDK is available, render both boards
    const initializeCanny = () => {
      if (window.Canny && typeof window.Canny === 'function') {
        // Feedback & Feature Requests board
        window.Canny('render', {
          boardToken: 'e19cd170-76dc-2d72-f442-b82b50d4148d',
          basePath: null,
          ssoToken: token,
          theme: 'dark',
          element: document.getElementById('canny-feedback'),
        });

        // Changelog board (replace with your actual changelog board token)
        window.Canny('render', {
          boardToken: 'YOUR_CHANGELOG_BOARD_TOKEN',
          boardType: 'changelog',
          basePath: null,
          theme: 'dark',
          element: document.getElementById('canny-changelog'),
        });
      } else {
        // Retry if not ready
        setTimeout(initializeCanny, 100);
      }
    };

    // Delay initialization to give SDK time to load
    const timer = setTimeout(initializeCanny, 500);

    // Cleanup on unmount
    return () => {
      clearTimeout(timer);
      window.removeEventListener('load', loadCannySDK);
    };
  }, [token]);

  return (
    <>
      <Head>
        <title>Feedback & Feature Requests | WhereCanWeDance</title>
        <meta property="og:title" content="Feedback & Feature Requests | WhereCanWeDance" />
        <meta
          property="og:description"
          content="We want to hear from you! Share your feedback, feature requests, and bug reports with us. We're always looking to improve our platform and make it better for you!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/assets/FEATURE REQUESTS WCWD.jpg" />
      </Head>

      <div className="container index">
        <h1 style={{ fontWeight: 700 }} className="text-center text-white">
          Feature Requests & Feedback
        </h1>
        <br />

        {/* Feedback board */}
        <div data-canny id="canny-feedback"></div>

        {/* Changelog board */}
        <div data-canny id="canny-changelog" style={{ marginTop: 32 }}></div>
      </div>
    </>
  );
};

// Set the layout
Feedback.layout = (page: React.ReactElement) => <Layout>{page}</Layout>;

export default Feedback;
